import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Game from '@/components/Game'
import Parents from '@/components/Parents'
import Guard from '@/components/Guard'
import Service from '@/components/Service'
import About from '@/components/About'
import Introduce from '@/components/Introduce'
import Team from '@/components/Team'
import Contact from '@/components/Contact'
import Login from '@/components/Login'
import Register from '@/components/Register'
import Recharge from '@/components/Recharge'
import Protocol from '@/components/Protocol'
import Certificate from '@/components/Certificate'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/home',
    },
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/game',
      name: 'Game',
      component: Game
    },
    {
      path: '/parents',
      name: 'Parents',
      component: Parents,
      redirect: '/parents/guard',
      children: [
        { path: '/parents/guard', name: 'Guard', component: Guard },
        { path: '/parents/service', name: 'Service', component: Service }
      ]
    },
    {
      path: '/about',
      name: 'About',
      component: About,
      redirect: '/about/introduce',
      children: [
        { path: '/about/introduce', name: 'Introduce', component: Introduce },
        { path: '/about/team', name: 'Team', component: Team },
        { path: '/about/contact', name: 'Contact', component: Contact }
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/register',
      name: 'Register',
      component: Register
    },
    {
      path: '/recharge',
      name: 'Recharge',
      component: Recharge
    },
    {
      path: '/protocol',
      name: 'Protocol',
      component: Protocol
    },
    {
      path: '/certificate',
      name: 'Certificate',
      component: Certificate
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js